import { BlockingInterfacesContextValue } from './types';
import { createContext } from 'react';

export const BlockingInterfacesContext = createContext<BlockingInterfacesContextValue | null>(null);